const LOTQ_ORIGINS = new Set([
  "https://lordofthequiz.com.br",
  "https://www.lordofthequiz.com.br",
  (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, ""),
]);

export function toInternalNotificationPath(target) {
  if (typeof target !== "string" || !target.trim()) return null;
  const value = target.trim();
  if (value.startsWith("/") && !value.startsWith("//")) return value;

  try {
    const url = new URL(value);
    if (!LOTQ_ORIGINS.has(url.origin)) return null;
    return `${url.pathname}${url.search}${url.hash}` || "/";
  } catch {
    return null;
  }
}

export function getNotificationDestination(target, fallback = "/notificacoes") {
  return toInternalNotificationPath(target) || target?.trim?.() || fallback;
}
